export type Color = {
  raw: string;
  css: string;
  tailwind: string;
};
export type ColorKeys = keyof typeof colorDefinition;
export type Colors = { [key in ColorKeys]: Color };

const colorDefinition = {
  // HEADS UP! This is the source of truth for colors
  // TODO: Generate on build a colors.css file with css variables
  // these are currently on globals-homepage.css
  transparent: 'transparent',
  white: '#ffffff',
  'grey-20': '#f9f9f9',
  'white-grey-20': '#f9f9f9',
  'grey-50': '#f7f7f7',
  'grey-100': '#e5e5e5',
  'grey-300': '#ababab',
  'grey-500': '#808080',
  'grey-700': '#4d4d4d',
  'grey-900': '#161D2C',
  black: '#2C2C2C',
  'dark-rose-light': '#c2a1a5',
  'dark-rose': '#a47379',
  'dark-rose-dark': '#745256',
  'cream-light': '#f9f6f5',
  cream: '#ece2df',
  'cream-dark': '#d1c1bc',
  'dark-green-light': '#818F92',
  'dark-green': '#183E40',
  'dark-green-middle': '#183E41',
  'dark-green-dark': '#183E3F',
  'light-green-cta': '#0d6363',
  'light-green-light-middle': '#1F6264',
  'light-green-light': '#4C8380',
  'light-green': '#0d6363',
  'light-green-middle': '#1E6363',
  'light-green-dark': '#094646',
  'light-mauve-light': '#f4f2f5',
  'light-mauve': '#ff6600',
  'light-mauve-dark': '#9b979e',
  'porch-swing': '#597175',
  'light-grey': '#dde8e9',
  'dtWhite-mbBlack': '#dtWhite-mbBlack',
};

const colorFormatObject = (name, color): Color => ({
  raw: color,
  css: `--color-${name}`,
  tailwind: `color-${name}`,
});

const buildColorSet = set =>
  Object.keys(set).reduce((colors, colorKey) => {
    const colorObject = colorFormatObject(colorKey, set[colorKey]);
    colors[colorKey] = colorObject;
    return colors;
  }, {} as Colors);

const colors = buildColorSet(colorDefinition);

export const colorsArray = Object.keys(colors).map(name => ({ name, ...colors[name] }));

export default colors;
